import { RolloverRecommendationAction } from "../../enums";
import { MasteryLevel, AssignmentCategory, MasteryPacing } from "@/enums";
import { RecommendationRule } from "@/models";

export const recommendationRules: RecommendationRule[] = [
  {
    scenario: "Student has mastered skill",
    skillType: undefined,
    startMastery: undefined,
    endMastery: MasteryPacing.AHEAD_OF_GRADE_LEVEL,
    recommendationCompleted: RolloverRecommendationAction.MoveOn,
    recommendationIncomplete: RolloverRecommendationAction.MoveOn,
  },
  {
    scenario: "Student has grown in skill",
    skillType: undefined,
    startMastery: MasteryPacing.BELOW_GRADE_LEVEL,
    endMastery: MasteryPacing.AT_GRADE_LEVEL,
    recommendationCompleted: RolloverRecommendationAction.MoveOn,
    recommendationIncomplete: RolloverRecommendationAction.MoveOn,
  },
  {
    scenario: "Assignments didn't produce growth",
    skillType: undefined,
    startMastery: undefined,
    endMastery: MasteryPacing.BELOW_GRADE_LEVEL,
    recommendationCompleted: RolloverRecommendationAction.RecommendPrerequisite,
    recommendationIncomplete: RolloverRecommendationAction.CompleteAssignments,
  },
  {
    scenario: "Developing at end of week and didn't show growth during the week",
    skillType: undefined,
    startMastery: MasteryPacing.AT_GRADE_LEVEL,
    endMastery: MasteryPacing.AT_GRADE_LEVEL,
    recommendationCompleted: RolloverRecommendationAction.AddSkillTutoring,
    recommendationIncomplete: RolloverRecommendationAction.CompleteAssignments,
  },
  {
    scenario: "Developing at end of week and didn't show growth during the week",
    skillType: undefined,
    startMastery: MasteryPacing.AHEAD_OF_GRADE_LEVEL,
    endMastery: MasteryPacing.AT_GRADE_LEVEL,
    recommendationCompleted: RolloverRecommendationAction.AddSkillTutoring,
    recommendationIncomplete: RolloverRecommendationAction.CompleteAssignments,
  },
  {
    scenario: "Rolled over once already (rollover activity in last week's plan)",
    skillType: AssignmentCategory.ROLLOVER,
    startMastery: undefined,
    endMastery: MasteryPacing.BELOW_GRADE_LEVEL,
    recommendationCompleted: RolloverRecommendationAction.TeacherInstruction,
    recommendationIncomplete: RolloverRecommendationAction.CompleteAssignments,
  },
  {
    scenario: "Rolled over once already (rollover activity in last week's plan)",
    skillType: AssignmentCategory.ROLLOVER,
    startMastery: undefined,
    endMastery: MasteryPacing.AHEAD_OF_GRADE_LEVEL,
    recommendationCompleted: RolloverRecommendationAction.MoveOn,
    recommendationIncomplete: RolloverRecommendationAction.MoveOn,
  },
  {
    scenario: "Rolled over once already (rollover activity in last week's plan)",
    skillType: AssignmentCategory.ROLLOVER,
    startMastery: undefined,
    endMastery: MasteryPacing.AT_GRADE_LEVEL,
    recommendationCompleted: RolloverRecommendationAction.MoveOn,
    recommendationIncomplete: RolloverRecommendationAction.MoveOn,
  },
];